import React from "react";

export default function LaborDayFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-lab22{fill:#edab07}.cls-lab23{fill:#ffbf00}.cls-lab24{fill:#fcc447}"
            }
          </style>
        </defs>
        <path
          d="M1479.22 1931.65H520.79c-93.08 0-168.81-75.73-168.81-168.81V804.41c0-93.08 75.73-168.81 168.81-168.81h958.43c93.08 0 168.81 75.73 168.81 168.81v958.43c0 93.08-75.73 168.81-168.81 168.81ZM520.78 683.77c-66.52 0-120.64 54.12-120.64 120.64v958.43c0 66.52 54.12 120.64 120.64 120.64h958.43c66.52 0 120.64-54.12 120.64-120.64V804.41c0-66.52-54.12-120.64-120.64-120.64H520.78Z"
          style={{
            fill: "#540375",
          }}
        />
        <path
          d="M1416.79 537.15v122.53H583.21V537.15c0-152.55 81.95-285.96 204.23-358.58 4.9-2.91 9.86-5.73 14.89-8.43 58.82-31.75 126.15-49.78 197.67-49.78 115.09 0 219.29 46.65 294.72 122.07 75.42 75.43 122.07 179.62 122.07 294.72Z"
          className="cls-lab23"
        />
        <path
          d="M1416.79 537.15v122.53H583.21V554.69c5.33 2.36 11.24 3.66 17.45 3.66h691.56c23.87 0 43.22-19.35 43.22-43.23v-50.5c0-88.04-43.54-167.75-113.93-225.45-70.41-57.69-167.66-93.39-275.07-93.39-47.77 0-93.53 7.06-135.81 19.98 56.82-29.03 121.19-45.41 189.38-45.41 115.09 0 219.29 46.65 294.72 122.07 75.42 75.43 122.07 179.62 122.07 294.72Z"
          className="cls-lab22"
        />
        <rect
          width={936.72}
          height={121.74}
          x={531.64}
          y={604.01}
          className="cls-lab23"
          rx={60.87}
          ry={60.87}
        />
        <path
          d="M1468.36 664.88c0 16.81-6.81 32.03-17.83 43.05-11.02 11.02-26.24 17.83-43.05 17.83H592.51c-33.62 0-60.87-27.25-60.87-60.87 0-16.74 6.75-31.91 17.7-42.91a51.11 51.11 0 0 0-6.9 25.69v1.47c0 28.31 22.95 51.26 51.26 51.26h807.99c28.31 0 51.26-22.95 51.26-51.26v-1.47c0-13.27-5.04-25.36-13.31-34.47 17.24 10.74 28.72 29.87 28.72 51.69Z"
          className="cls-lab22"
        />
        <path
          d="M1029.02 413.38h-54.24c-26.76 0-49.14-24.7-51.66-57.02-5.7-73.03-11.4-146.06-17.11-219.1-2.89-36.95 21.07-68.9 51.66-68.9h84.66c30.16 0 53.97 31.09 51.75 67.59-4.44 73.03-8.87 146.06-13.31 219.1-2 32.89-24.57 58.33-51.75 58.33Z"
          className="cls-lab23"
        />
        <path
          d="M1042.33 68.35h-84.66c-30.6 0-54.55 31.95-51.65 68.91 5.7 73.02 11.4 146.06 17.11 219.09 2.52 32.33 24.89 57.02 51.65 57.02h54.25c27.17 0 49.75-25.44 51.74-58.33 4.44-73.03 8.87-146.06 13.31-219.09 2.22-36.5-21.59-67.59-51.75-67.59Zm36.92 79.02c-3.74 65.08-7.47 130.16-11.2 195.24-1.69 29.32-20.71 51.99-43.6 51.99h-45.69c-22.54 0-41.39-22.01-43.51-50.82-4.81-65.08-9.61-130.16-14.41-195.25-2.43-32.92 17.75-61.39 43.52-61.39h71.3c25.41 0 45.46 27.7 43.6 60.23ZM803.22 174.4l-27.94 404.66c-.29 4.17-3.7 7.36-7.73 7.34-.18 0-.34 0-.52-.01-4.26-.31-7.47-4.09-7.16-8.44l27.57-399.37c4.9-2.91 9.86-5.73 14.89-8.43.66 1.27.99 2.73.88 4.26ZM1231.71 586.45c-4.03 0-7.43-3.13-7.7-7.21l-26.52-395.75c-.29-4.26 2.93-7.94 7.19-8.23a7.732 7.732 0 0 1 8.23 7.19l26.52 395.75c.29 4.26-2.93 7.94-7.19 8.23-.18.01-.35.02-.52.02Z"
          className="cls-lab22"
        />
        <path
          d="M931.63 165.39c-.16 66.4 4.14 145.47 7.61 145.13 3.11-.31 3.38-64.17 13.53-148.79 1.02-8.48 2.58-20.27 10.99-31.28 24.41-31.94 80.31-23.05 80.31-27.9 0-3.64-31.49-8.13-65.1-4.23-14.43 1.67-21.79 2.61-28.74 7.61-18.12 13.02-18.56 41-18.6 59.46ZM570.12 659.62c16.75 32.86 78.21 25.38 213.04 25.36 108.41-.01 159.48 4.82 159.78.85.36-4.79-74.46-3.95-186.84-29.59-104.05-23.74-168.29-53.74-185.99-29.59-6.71 9.15-4.83 23.49 0 32.97ZM747.03 352.08c-6.85 71.6 3.14 132.61 6.76 132.73 3.09.1 4.08-43.96 13.7-151.51 8-89.55 12.38-115.63.63-121.08-20.8-9.64-73.4 54.01-66.74 62.93 4.18 5.6 28.57-14.58 43.12-5.07 14.67 9.59 6.47 40.97 2.54 82.01Z"
          className="cls-lab24"
        />
        {children}
      </g>
    </svg>
  );
}
